export type UpdateIFDefinitionsGodResponse = {
  /**
   * The results of this update_if_definitions_god response body.
   */
  result: GodResult[];
  pjtId: string;
};

export type GodResult = {
  idx: number;
  ifReqId: string;
  message: Message[];
};

type Message = {
  val: string;
  col: string[];
};
